/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServerInfoResponse } from '../../models/server-info-response';

export interface InfoControllerGetServerInfo$Params {
}

export function infoControllerGetServerInfo(http: HttpClient, rootUrl: string, params?: InfoControllerGetServerInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, infoControllerGetServerInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServerInfoResponse>;
    })
  );
}

infoControllerGetServerInfo.PATH = '/planning-projects/v1/info';
